import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  loggedIn: boolean = false;
  tokenObj: any;
  invoiceId: any;
  constructor(private route: Router, private auth: AuthService){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.auth.checkLogin();
      this.auth.isUserLoggedIn.subscribe( (val) => {
        if(val) {
          this.loggedIn = true;
        } else { this.loggedIn = false; }
      });
      if(this.loggedIn) {
          this.tokenObj = state.root.queryParams;
          if(this.tokenObj.invoice_token){
            this.fetchInvoiceId();
          }
          else{
            this.route.navigate(['/dashboard']);
          }
        return false;
      } else { 
        return true; 
      }
  }
  
  fetchInvoiceId() {
    this.auth.publicInvoice(this.tokenObj).subscribe((res: any)=>{
      this.invoiceId = res.data.invoice.id;
      this.route.navigate(['/dashboard/invoice/' + this.invoiceId]);
    });
  }
}
